<template>
  <div class="content-controls">
    <div class="content-column content-column--left">
      <dropdown-input
        v-if="folder.purpose && folder.purpose !== 'inbox'"
        :options="dropdownShareOptions"
        position="left"
        @select="handleDropdownShareSelect"
      >
        <button-input>
          <font-awesome-icon icon="share-alt" />
          <span
            v-t="'c.contentControls.navigation.share'"
            class="visible-md"
          />
        </button-input>
      </dropdown-input>

      <dropdown-input
        v-if="folder.purpose && folder.purpose !== 'inbox'"
        :options="dropdownOptions"
        position="left"
        @select="handleDropdownSelect"
      >
        <button-input>
          <font-awesome-icon icon="cog" />
          <font-awesome-icon icon="angle-down" />
        </button-input>
      </dropdown-input>
    </div>

    <div class="content-column content-column--center">
      <content-layout-switch />
    </div>

    <div class="content-column content-column--right">
      <button-input
        class="content__share-button"
        @click="openFilterModal()"
      >
        <font-awesome-icon icon="filter" />
        <span
          v-t="'c.contentControls.navigation.filter'"
          class="visuallyhidden"
        />

      </button-input>
    </div>

    <content-filter-overlay />
    <content-export-overlay />
    <folder-settings-overlay />
    <mailing-overlay />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ContentLayoutSwitch from '@/components/contents/ContentLayoutSwitch'
import ContentFilterOverlay from '@/components/contents/ContentFilterOverlay'
import ContentExportOverlay from '@/components/contents/ContentExportOverlay'
import FolderSettingsOverlay from '@/components/folders/FolderSettingsOverlay'
import MailingOverlay from '@/components/mailings/MailingOverlay'

export default {
  name: 'ContentControls',
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon,
    ContentLayoutSwitch,
    ContentFilterOverlay,
    ContentExportOverlay,
    FolderSettingsOverlay,
    MailingOverlay
  },
  computed: {
    ...mapState({
      folder: state => state.folder.folder
    }),
    dropdownShareOptions () {
      return [
        { label: 'Newsletter', value: 'newsletter', icon: 'paper-plane' },
        { label: 'Exportieren', value: 'export', icon: 'cloud-upload-alt' },
      ]
    },
    dropdownOptions () {
      return [
        { label: 'Bearbeiten', value: 'edit', icon: 'edit' },
        { label: 'Löschen', value: 'delete', icon: 'trash' }
      ]
    }
  },
  methods: {
    ...mapActions([
      'openOverlay',
      'openConfirmModal',
      'closeConfirmModal',
      'destroyFolder',
      'openFullscreenModal'
    ]),
    openShareContentModal () {
      this.openFullscreenModal('mailingOverlay')
    },
    openExportModal () {
      this.openFullscreenModal('ContentExportOverlay')
    },
    openSettingsModal () {
      this.openOverlay('FolderSettingsOverlay')
    },
    openFilterModal () {
      this.openOverlay('ContentFilterOverlay')
    },
    handleDropdownShareSelect ({ value }) {
      switch (value) {
        case 'export':
          this.openExportModal()
          break
        case 'newsletter':
          this.openShareContentModal()
          break
        }
    },
    handleDropdownSelect ({ value }) {
      switch (value) {
        case 'edit':
          this.openSettingsModal()
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Folda löschen',
            message: `Den Folda ${this.folder.name} wirklich löschen?`,
            callback: () => {
              this.destroyFolder(this.folder.id)
                .then(this.closeConfirmModal)
                .then(() => {
                  this.$router.push({ path: `/foldaz#${this.folder.team.slug}` })
                })
            }
          })
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.content-controls
  display: flex
  justify-content: space-between
  margin-bottom: 20px

  +respond-max($md)
    flex-wrap: wrap

  .content-column
    width: 33%

    &--left
      display: flex
      justify-content: flex-start

      +respond-max($md)
        order: 2
        width: unset

      > *
        margin-right: 10px

    &--center
      display: flex
      justify-content: center

      +respond-max($md)
        order: 1
        width: 100%
        margin-bottom: 15px

    &--right
      display: flex
      justify-content: flex-end

      +respond-max($md)
        order: 2
        width: unset

    .button-input
      background-color: var(--mainColor)
</style>





// WEBPACK FOOTER //
// src/components/contents/ContentControls.vue